import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const ToolbarDuplicateSplatIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21.42 0.25H9.12001C8.16001 0.25 7.37001 1.04 7.37001 2V5.75H3.17001C2.15001 5.75 1.32001 6.58 1.32001 7.6V21.9C1.32001 22.92 2.15001 23.75 3.17001 23.75H15.27C16.29 23.75 17.12 22.92 17.12 21.9V18.25H21.42C22.38 18.25 23.17 17.46 23.17 16.5V2C23.17 1.04 22.38 0.25 21.42 0.25ZM15.62 21.9C15.62 22.09 15.46 22.25 15.27 22.25H3.17001C2.98001 22.25 2.82001 22.09 2.82001 21.9V7.6C2.82001 7.41 2.98001 7.25 3.17001 7.25H7.37001V16.5C7.37001 17.46 8.16001 18.25 9.12001 18.25H15.62V21.9ZM21.67 16.5C21.67 16.64 21.56 16.75 21.42 16.75H9.12001C8.98001 16.75 8.87001 16.64 8.87001 16.5V2C8.87001 1.86 8.98001 1.75 9.12001 1.75H21.42C21.56 1.75 21.67 1.86 21.67 2V16.5Z"
        fill={color}
      />
      <path
        d="M12.91 5.25H11.9C11.5576 5.25 11.28 5.52758 11.28 5.87V6.88C11.28 7.22242 11.5576 7.5 11.9 7.5H12.91C13.2524 7.5 13.53 7.22242 13.53 6.88V5.87C13.53 5.52758 13.2524 5.25 12.91 5.25Z"
        fill={color}
      />
      <path
        d="M12.91 11H11.9C11.5576 11 11.28 11.2776 11.28 11.62V12.63C11.28 12.9724 11.5576 13.25 11.9 13.25H12.91C13.2524 13.25 13.53 12.9724 13.53 12.63V11.62C13.53 11.2776 13.2524 11 12.91 11Z"
        fill={color}
      />
      <path
        d="M18.66 11H17.65C17.3076 11 17.03 11.2776 17.03 11.62V12.63C17.03 12.9724 17.3076 13.25 17.65 13.25H18.66C19.0024 13.25 19.28 12.9724 19.28 12.63V11.62C19.28 11.2776 19.0024 11 18.66 11Z"
        fill={color}
      />
      <path
        d="M18.66 5.25H17.65C17.3076 5.25 17.03 5.52758 17.03 5.87V6.88C17.03 7.22242 17.3076 7.5 17.65 7.5H18.66C19.0024 7.5 19.28 7.22242 19.28 6.88V5.87C19.28 5.52758 19.0024 5.25 18.66 5.25Z"
        fill={color}
      />
      <path
        d="M15.78 8.12H14.77C14.4276 8.12 14.15 8.39758 14.15 8.74V9.75C14.15 10.0924 14.4276 10.37 14.77 10.37H15.78C16.1224 10.37 16.4 10.0924 16.4 9.75V8.74C16.4 8.39758 16.1224 8.12 15.78 8.12Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ToolbarDuplicateSplatIcon.displayName = 'ToolbarDuplicateSplatIcon';
